import { render, staticRenderFns } from "./DetectIPComponent.vue?vue&type=template&id=600a0ada&scoped=true"
import script from "./DetectIPComponent.vue?vue&type=script&lang=js"
export * from "./DetectIPComponent.vue?vue&type=script&lang=js"
import style0 from "./DetectIPComponent.vue?vue&type=style&index=0&id=600a0ada&prod&lang=css"
import style1 from "./DetectIPComponent.vue?vue&type=style&index=1&id=600a0ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600a0ada",
  null
  
)

export default component.exports